const key = 'remotion-editor-starter.skimming-enabled';

export const DEFAULT_SKIMMING_ENABLED = false;

export const loadSkimmingEnabled = () => {
  if (typeof localStorage === 'undefined') {
    return DEFAULT_SKIMMING_ENABLED;
  }

  const value = localStorage.getItem(key);
  if (value === null) {
    return DEFAULT_SKIMMING_ENABLED;
  }
  return value === 'true';
};

export const saveSkimmingEnabled = (enabled: boolean) => {
  localStorage.setItem(key, enabled.toString());
};
